import React from 'react';
import {Link} from 'gatsby';
import Layout from '../components/layout';
import '../styles/years.scss';

function FourthYearPage() {
  return (
    <Layout>
      <main className="page-main">
        <h1 className="page-title-center">Fourth Year</h1>

        <p className="center-block">Overall Year Grade: TBC</p>

        <div className="block"></div>

        <section className="section-light">
            <h2 className="subtitle-center">More information coming soon!</h2>
        </section>

      </main>
    </Layout>
  );
}

export default FourthYearPage;